module.exports = __webpack_public_path__ + "static/chicago-il-line-drawing-e6c0548da9272fbf87eac7d4bab965f8.svg";